import React, {forwardRef, InputHTMLAttributes, ReactNode} from 'react';

import {Indicator, Label, NativeInput, Root} from './styled';

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    children?: ReactNode;
    isList?: boolean;
    sizes?: {
        width: number;
        height: number;
    };
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
    ({children, disabled = false, checked = false, sizes, isList = false, ...otherProps}, ref) => {
        const hasLabel = Boolean(children);

        return (
            <Root hasLabel={hasLabel} disabled={disabled} isList={isList}>
                <NativeInput
                    ref={ref}
                    type="checkbox"
                    checked={checked}
                    disabled={disabled}
                    {...otherProps}
                />

                <Indicator checked={checked} disabled={disabled} sizes={sizes} />

                {hasLabel && (
                    <Label disabled={disabled} isList={isList}>
                        {children}
                    </Label>
                )}
            </Root>
        );
    },
);
